<template>
  <div>
    <mu-text-field
      :min="0"
      inputClass="currencyInput"
      @blur="isInputActive = false"
      @focus="isInputActive = true"
      @change="changed()"
      v-model.number="inputValue"
      :hintText="'Enter in ' + currency.currencyCode"
      :helpText="displayValue +  ' ' + $t('message.labelPerWeek')"
      :label="label"
      :type="castingType"
      :fullWidth="true"
    />
  </div>
</template>
<script>

  

  export default {
    name: 'currency-input',
    props: {
      value: {
        type: Number
      },
      currency: {
        type: Object
      },
      label: {
        type: String,
        default: "Weekly grocery cost"
      }
    },
    data() {
      return {
        inputValue: 0,
        castingType: "number",
        isInputActive: false,
        currencyElement: undefined
      }
    },
    mounted() {
      let self = this;
      self.inputValue = self.value;
      self.currencyElement = $('.currencyInput');
    },
    computed: {
      displayValue() {
        let self = this;
        if(Number.isFinite(self.inputValue) || Number.isInteger(self.inputValue)) {
          return self.currency.currencySymbol + ' ' + self.inputValue.toFixed(2).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")
        }
        return self.currency.currencySymbol + 0;
      }
    },
    methods: {
      changed() {
        let self = this;
        const elementText = self.currencyElement.val();
        self.$emit('input', elementText);
      },
      formatString(str) {
        let splitStr = str.toLowerCase().split(' ');
        for (var i = 0; i < splitStr.length; i++) {
          splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
        }
        return splitStr.join(' ');

      }
    }
  }
</script>



// WEBPACK FOOTER //
// CurrencyInput.vue?90618d9e